import { useApiClient } from '@/composables/useApiClient'

export interface IHubTimezone {
  timezone: string
}

export const useGeneralService = () => {
  const privateApi = useApiClient(true)

  /**
   * Zona horaria del sistema (`generals` flag 13).
   *
   * Va bajo `/general/timezone` del namespace del hub: la API del hub se
   * alcanza por `/hub/api/*`, que Traefik reescribe a `/api/hub/*`, asi que el
   * `/general` plano de voice no es alcanzable desde aca.
   */
  const getTimezone = async () => {
    return privateApi.get<IHubTimezone>('/general/timezone')
  }

  return {
    getTimezone,
  }
}
